import { createResource } from '../utils/resource'

const reportStore = createResource('report', {})

export default reportStore